import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://education-crm-2b77a26760ff.herokuapp.com/api';

const INTEREST_OPTIONS = ['AI/ML', 'Web Dev', 'Data Science', 'Cybersecurity', 'Cloud', 'Robotics', 'Other'];
const COURSE_OPTIONS = ['B.Tech', 'M.Tech', 'MBA', 'BCA', 'MCA', 'BSc', 'MSc', 'BE', 'ME', 'Diploma', 'Other'];

const inputStyle = {
  width: '100%', padding: '12px 14px', fontSize: 15, border: '1.5px solid #e2e8f0',
  borderRadius: 10, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box',
  background: '#fff', color: '#1e293b',
};
const labelStyle = { fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 4, display: 'block' };

export default function RegisterPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [partner, setPartner] = useState(null);
  const [loadingPartner, setLoadingPartner] = useState(!!slug);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const [form, setForm] = useState({
    name: '', email: '', phone: '', city: '', college: '',
    course: '', graduation_year: '', interest_area: 'AI/ML',
    current_salary_expectation: '', desired_salary_after_program: '',
  });

  // Detect source from URL
  const urlParams = new URLSearchParams(window.location.search);
  const utm_medium = urlParams.get('utm_medium') || (slug ? 'qr_code' : 'direct_link');

  useEffect(() => {
    if (!slug) return;
    axios.get(`${BASE_URL}/public/partner/${slug}`)
      .then(r => setPartner(r.data?.data))
      .catch(() => setPartner(null))
      .finally(() => setLoadingPartner(false));
  }, [slug]);

  const set = (field, value) => setForm(f => ({ ...f, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name.trim() || !form.email.trim() || !form.phone.trim()) {
      setError('Name, email and phone are required.');
      return;
    }
    setSubmitting(true);
    try {
      const payload = { ...form, registration_source: utm_medium };
      const url = slug ? `${BASE_URL}/public/register/${slug}` : `${BASE_URL}/public/register/direct`;
      await axios.post(url, payload);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loadingPartner) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9' }}>
      <div style={{ width: 40, height: 40, border: '3px solid #C9A84C', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    </div>
  );

  if (submitted) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1B2A6B 0%, #2d3f8a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: '40px 32px', textAlign: 'center', maxWidth: 420, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: '#1B2A6B', marginBottom: 8 }}>Registration Successful!</h2>
        <p style={{ color: '#64748b', fontSize: 15, lineHeight: 1.6 }}>
          Thank you, {form.name.split(' ')[0]}! We've received your registration and will contact you shortly about the next steps.
        </p>
        {partner && (
          <p style={{ color: '#475569', fontSize: 13, marginTop: 16 }}>
            Registered via <strong>{partner.contact_name}</strong> · {partner.college_name}
          </p>
        )}
        <div style={{ marginTop: 24, padding: '16px', background: '#f8fafc', borderRadius: 12 }}>
          <p style={{ fontSize: 13, color: '#64748b', margin: 0 }}>📲 Keep an eye on your phone — we'll reach out within 24 hours!</p>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1B2A6B 0%, #2d3f8a 100%)', padding: '20px 16px 40px' }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        input:focus, select:focus { border-color: #C9A84C !important; box-shadow: 0 0 0 3px rgba(201,168,76,0.15); }
      `}</style>

      {/* Header */}
      <div style={{ maxWidth: 500, margin: '0 auto 24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
          <div style={{ width: 40, height: 40, background: '#C9A84C', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>⚡</div>
          <div>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 16 }}>Nova Era Labs</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>AI & Technology Training</div>
          </div>
        </div>

        <h1 style={{ color: '#fff', fontSize: 26, fontWeight: 800, lineHeight: 1.3, margin: 0 }}>
          Register for Free<br />
          <span style={{ color: '#C9A84C' }}>AI Lab Training</span>
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 14, marginTop: 8 }}>
          GPU labs • Live projects • Scholarship opportunities • Career support
        </p>

        {partner && (
          <div style={{ marginTop: 14, padding: '10px 14px', background: 'rgba(255,255,255,0.1)', borderRadius: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 18 }}>👤</span>
            <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13 }}>
              Referred by <strong>{partner.contact_name}</strong>
              {partner.college_name && ` · ${partner.college_name}`}
            </span>
          </div>
        )}
      </div>

      {/* Form Card */}
      <div style={{ maxWidth: 500, margin: '0 auto', background: '#fff', borderRadius: 20, padding: '28px 24px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: '#1B2A6B', margin: '0 0 20px' }}>Your Details</h2>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gap: 16 }}>
            {/* Name */}
            <div>
              <label style={labelStyle}>Full Name *</label>
              <input style={inputStyle} placeholder="e.g. Rahul Sharma" value={form.name}
                onChange={e => set('name', e.target.value)} required />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {/* Email */}
              <div>
                <label style={labelStyle}>Email *</label>
                <input style={inputStyle} type="email" placeholder="you@email.com" value={form.email}
                  onChange={e => set('email', e.target.value)} required />
              </div>
              {/* Phone */}
              <div>
                <label style={labelStyle}>Phone *</label>
                <input style={inputStyle} type="tel" placeholder="9876543210" value={form.phone}
                  onChange={e => set('phone', e.target.value)} required />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {/* City */}
              <div>
                <label style={labelStyle}>City</label>
                <input style={inputStyle} placeholder="e.g. Hyderabad" value={form.city}
                  onChange={e => set('city', e.target.value)} />
              </div>
              {/* College */}
              <div>
                <label style={labelStyle}>College / University</label>
                <input style={inputStyle} placeholder="College name" value={form.college}
                  onChange={e => set('college', e.target.value)} />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {/* Course */}
              <div>
                <label style={labelStyle}>Course</label>
                <select style={inputStyle} value={form.course} onChange={e => set('course', e.target.value)}>
                  <option value="">Select</option>
                  {COURSE_OPTIONS.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              {/* Graduation Year */}
              <div>
                <label style={labelStyle}>Graduation Year</label>
                <select style={inputStyle} value={form.graduation_year} onChange={e => set('graduation_year', e.target.value)}>
                  <option value="">Select</option>
                  {[2024, 2025, 2026, 2027, 2028].map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
            </div>

            {/* Interest Area */}
            <div>
              <label style={labelStyle}>Area of Interest</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {INTEREST_OPTIONS.map(opt => (
                  <button key={opt} type="button"
                    onClick={() => set('interest_area', opt)}
                    style={{
                      padding: '7px 14px', borderRadius: 20, border: '1.5px solid',
                      fontSize: 13, cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s',
                      background: form.interest_area === opt ? '#1B2A6B' : '#f8fafc',
                      color: form.interest_area === opt ? '#fff' : '#475569',
                      borderColor: form.interest_area === opt ? '#1B2A6B' : '#e2e8f0',
                      fontWeight: form.interest_area === opt ? 700 : 500,
                    }}>
                    {opt}
                  </button>
                ))}
              </div>
            </div>

            {/* ROI Section */}
            <div style={{ background: '#f0fdf4', border: '1.5px solid #bbf7d0', borderRadius: 12, padding: '14px 16px' }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: '#15803d', margin: '0 0 10px' }}>📈 Quick ROI Estimator (optional)</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div>
                  <label style={{ ...labelStyle, fontSize: 12 }}>Expected Salary Now (LPA)</label>
                  <input style={{ ...inputStyle, padding: '9px 12px', fontSize: 14 }} type="number" placeholder="3.5"
                    value={form.current_salary_expectation}
                    onChange={e => set('current_salary_expectation', e.target.value)} />
                </div>
                <div>
                  <label style={{ ...labelStyle, fontSize: 12 }}>Target Salary After Program (LPA)</label>
                  <input style={{ ...inputStyle, padding: '9px 12px', fontSize: 14 }} type="number" placeholder="8.5"
                    value={form.desired_salary_after_program}
                    onChange={e => set('desired_salary_after_program', e.target.value)} />
                </div>
              </div>
            </div>

            {error && (
              <div style={{ background: '#fee2e2', color: '#dc2626', padding: '10px 14px', borderRadius: 10, fontSize: 13 }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={submitting}
              style={{
                width: '100%', padding: '14px', background: submitting ? '#94a3b8' : 'linear-gradient(135deg, #1B2A6B, #2d3f8a)',
                color: '#fff', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700,
                cursor: submitting ? 'not-allowed' : 'pointer', fontFamily: 'inherit', transition: 'all 0.2s',
              }}>
              {submitting ? 'Registering…' : '🚀 Register for Free'}
            </button>

            <p style={{ textAlign: 'center', fontSize: 11, color: '#94a3b8', margin: 0 }}>
              By registering, you agree to be contacted by Nova Era Labs. No spam.
            </p>
          </div>
        </form>
      </div>

      {/* Highlights */}
      <div style={{ maxWidth: 500, margin: '20px auto 0', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {[
          { icon: '🖥️', text: 'GPU Lab Access' },
          { icon: '🎓', text: 'Scholarship Available' },
          { icon: '💼', text: '85% Placement Rate' },
          { icon: '📜', text: 'Industry Certificate' },
        ].map(h => (
          <div key={h.text} style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 20 }}>{h.icon}</span>
            <span style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>{h.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
